import { catchError, tap } from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { BehaviorSubject, from, interval, Observable, of } from "rxjs";
import Swal from "sweetalert2"
import { ServiceResponseModel } from '../models/general/service-response.model';
import { HttpService } from './http.service';

@Injectable()
export class SweetAlertService {
  // result$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // confirmEmitter: EventEmitter<boolean> = new EventEmitter();
  result$: BehaviorSubject<ServiceResponseModel> = new BehaviorSubject<ServiceResponseModel>(new ServiceResponseModel);
  constructor(private httpService: HttpService) {
  }
  showMessage(
    type: string,
    message: string
  ) {
    Swal.fire({
      icon: type === 'error' ? 'error' : type === 'success' ? 'success' : type === 'warning' ? 'warning' : type === 'info' ? 'info' : 'question',
      title: type === 'error' ? 'Hata' : type === 'success' ? 'Başarılı' : type === 'warning' ? 'Uyarı' : type === 'info' ? 'Bilgi' : 'Soru',
      text: message,
      // footer: '<a href="">Why do I have this issue?</a>'
    })
  }

  /**
   * HTML destekli mesaj gösterimi
   */
  showHtmlMessage(
    type: string,
    htmlContent: string,
    title?: string
  ) {
    Swal.fire({
      icon: type === 'error' ? 'error' : type === 'success' ? 'success' : type === 'warning' ? 'warning' : type === 'info' ? 'info' : 'question',
      title: title || (type === 'error' ? 'Hata' : type === 'success' ? 'Başarılı' : type === 'warning' ? 'Uyarı' : type === 'info' ? 'Bilgi' : 'Soru'),
      html: htmlContent,
    })
  }
  showDelete<T>(
    name: string,
    model: T,
    action: string,
  ): Observable<ServiceResponseModel> {

    return from(Swal.fire({
      title: name + ' Silinecek?',
      text: "Silmek istiyor musunuz!",
      icon: 'warning',
      showConfirmButton: true,
      showDenyButton: true,
      // showCancelButton: true,
      confirmButtonColor: '#3085d6',
      denyButtonColor: '#d33',
      // cancelButtonColor: '#d33',
      confirmButtonText: 'Evet, sil!',
      denyButtonText: 'Hayır, silme!',
      allowOutsideClick: false,
      preConfirm: () => {

        Swal.update({
          showDenyButton: false,
          text: name + ' Siliniyor...',
        });
         Swal.showLoading();//Volkan

        // Gerçek bir Promise dönülür; böylece SweetAlert loading'i hem başarı
        // hem de hata durumunda kapanır. httpService.Post hata durumunda
        // observable'ı error ile sonlandırdığından catchError ile çözümlenmiş
        // değere çevrilir; aksi halde loading sonsuza kadar döner.
        return this.httpService.Post(action, model).pipe(
          tap(res => {
            this.result$.next(res);
          }),
          catchError(err => {
            const msg = err?.message || (name + ' silinemedi');
            this.result$.next({
              data: false,
              messageType: 'error',
              message: msg,
              appException: { appMessage: msg }
            } as ServiceResponseModel);
            return of({} as ServiceResponseModel);
          })
        ).toPromise();

      },
      preDeny: () => {
        this.result$.next(
          { data: false } as ServiceResponseModel
        );
      }

    }).then((result) => {
      
      if (result.isConfirmed) {
        if (this.result$.value.messageType === 'error') { 
          Swal.fire(
            'Hata!',
            name + ' Silinemedi.' + "<br>" + (this.result$.value.appException?.appMessage || this.result$.value.message || ''),
            'error'
          )
        }
        else {
          Swal.fire(
            'Silindi!',
            name + ' Silindi.',
            'success'
          )
        }
      }
      else if (result.isDenied) {
        Swal.fire(
          'Vazgeçtiniz!',
          'Kayıt Silinmedi.',
          'error'
        )
      }
      else if (result.isDismissed) {
        Swal.fire(
          'Vazgeçtiniz!',
          'Kayıt Silinmedi.',
          'success'
        )
      }
      else {
      };
      return this.result$.value;
    }))
  }
  showSave<T>(
    name: string,
    model: T,
    action: string,
    description: string,
  ): Observable<ServiceResponseModel> {

    return from(Swal.fire({
      title: name ,//+ ' Kaydedilecek?'
      text: "Kaydetmek istiyor musunuz!",
      icon: 'warning',
      showConfirmButton: true,
      showDenyButton: true,
      // showCancelButton: true,
      confirmButtonColor: '#3085d6',
      denyButtonColor: '#d33',
      // cancelButtonColor: '#d33',
      confirmButtonText: 'Evet, kaydet!',
      denyButtonText: 'Hayır, kaydetme!',
      allowOutsideClick: false,
      preConfirm: () => {
        Swal.update({
          showDenyButton: false,
          text: name + ' Kaydediliyor..',
        });
        Swal.showLoading();//Volkan

        // Gerçek bir Promise dönülür; hata durumunda da loading kapanır.
        return this.httpService.Post(action, model).pipe(
          tap(res => {
            this.result$.next(res);
          }),
          catchError(err => {
            const msg = err?.message || (name + ' kaydedilemedi');
            this.result$.next({
              data: false,
              messageType: 'error',
              message: msg,
              hasMessage: true,
              appException: { appMessage: msg }
            } as ServiceResponseModel);
            return of({} as ServiceResponseModel);
          })
        ).toPromise();

      },

    }).then((result) => {

      if (result.isConfirmed) {

        const res = this.result$.value
        if (res.messageType === 'error') {
          Swal.fire(
            'Hata!',
            name + ' Kaydedilemedi.' + "<br>" + (res.appException?.appMessage || res.message || ''),
            'error'
          )
        }
        else if (res.hasMessage === true && res.messageType === 'success') {
          Swal.fire(
            'Kaydedildi!',
            res.message,
            // name + ' Kaydedilemedi.'+"<br>"+this.result$.value.oysException.oysMessage,
            'success'
          )
        }
        // if (this.result$.value.hasOYSException) {
        //   Swal.fire(
        //     'Hata!',
        //     name + ' Kaydedilemedi.' + "<br>" + this.result$.value.oysException.oysMessage,
        //     'error'
        //   )
        // } else {
        //   Swal.fire(
        //     'Kaydedildi!',
        //     name + ' Kaydedildi.<br><br><b>' + description + '</b>',

        //     'success'
        //   )
        // }
      }
      else if (result.isDenied) {
        Swal.fire(
          'Vazgeçtiniz!',
          name + ' Kaydedilemedi.',
          'error'
        )

      }
      else if (result.isDismissed) {
        Swal.fire(
          'Vazgeçtiniz!',
          name + ' Kaydedilemedi.',
          'success'
        )
      }
      else {
      };

      return this.result$.value;
    }))
  }

  showMissingList<T>(

    missingList: string[],
    missingText: string = "",

  ): Observable<boolean> {
    return from(Swal.fire({
      title: "Aşağıda yer alan alanlar boş olamaz",
      html: "<div>" + missingText + "</div>",
      icon: 'error',
      showConfirmButton: true,
      // showDenyButton: false,
      // showCancelButton: true,
      confirmButtonColor: '#3085d6',
      denyButtonColor: '#d33',
      // cancelButtonColor: '#d33',
      confirmButtonText: 'Kapat',

      // denyButtonText: 'Hayır, silme!',
      //  : () => {
      //    Swal.update({
      //          ()=>

      //      html: missingText,
      //      text: name + ' Siliniyor...',
      //    });
      //  Swal.showLoading();
      // cancelButtonText: 'Vazgeç, silme!'

      // }
    }).then((result): boolean => {
      if (result.isConfirmed) {
        Swal.fire(
          'Bilgi!',
          'Eksik alanları tamamlayarak yeniden deneyiniz.',
          'success'
        )
        return true
      }
      else if (result.isDenied) {
        Swal.fire(
          'Bilgi!',
          'Eksik alanları tamamlayarak yeniden deneyiniz.',
          'success'
        )
        return false

      }
      else if (result.isDismissed) {
        Swal.fire(
          'Vazgeçtiniz!',
          'Dosyanız Silinmedi.',
          'success'
        )
        return false
      }
      else {
        return false
      }
    })
    )
  }

  /**
   * Basit başarı mesajı gösterir
   */
  showSuccess(message: string, title: string = 'Başarılı'): void {
    Swal.fire({
      icon: 'success',
      title: title,
      text: message,
      timer: 3000,
      showConfirmButton: false
    });
  }

  /**
   * Kendiliğinden kapanmayan, yalnızca butonla kapatılan bilgi penceresi.
   * Uzun içerikler (ör. kişi bilgileri listesi) için kullanılır: showSuccess 3 saniyede
   * kapandığı için çok satırlı metin okunamıyor.
   *
   * Metin HTML olarak yorumlanmaz; kaçışlanır ve yalnızca satır sonları korunur.
   */
  showDetailMessage(
    type: 'success' | 'error' | 'warning' | 'info',
    message: string,
    title?: string,
    confirmText: string = 'Tamam'
  ): void {
    const defaultTitle =
      type === 'error' ? 'Hata' : type === 'success' ? 'Başarılı' : type === 'warning' ? 'Uyarı' : 'Bilgi';

    Swal.fire({
      icon: type,
      title: title || defaultTitle,
      html: this.toHtmlLines(message),
      showConfirmButton: true,
      confirmButtonText: confirmText,
      allowOutsideClick: false
    });
  }

  /**
   * Düz metni HTML'e çevirir: özel karakterler kaçışlanır, satır sonları <br> olur.
   */
  private toHtmlLines(text: string): string {
    return (text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/\r?\n/g, '<br>');
  }

  /**
   * Basit hata mesajı gösterir
   */
  showError(message: string, title: string = 'Hata'): void {
    Swal.fire({
      icon: 'error',
      title: title,
      text: message
    });
  }

  /**
   * Basit uyarı mesajı gösterir
   */
  showWarning(message: string, title: string = 'Uyarı'): void {
    Swal.fire({
      icon: 'warning',
      title: title,
      text: message
    });
  }

  /**
   * Genel amaçlı (yan etki / API çağrısı olmayan) basit onay penceresi.
   * Neden eklendi?
   * - Var olan showDelete / showSave metotları özel backend POST akışı ve durum mesajları içeriyor; sıradan "devam et / vazgeç" senaryoları için ağır ve semantik olarak yanlış.
   * - Birçok component küçük teyit (modal kapat, mod değiştir, liste temizle vb.) ihtiyacı duyuyor; tekrar eden Swal.fire bloklarını tek merkezde toplamak bakım maliyetini ve UI tutarsızlığını azaltır.
   * Ne yapar?
   * - SweetAlert modalını opsiyonlarla açar ve sadece boolean (confirm edildi mi) döner.
   * - Varsayılan olarak iptal butonu gösterir ve dışarı tıklamayı kapatır.
   * Nasıl genişletilir?
   * - html alanı verilirse text yerine HTML içerik kullanılır.
   * - showCancelButton false yapılarak sadece bilgi amaçlı confirm penceresi gibi davranabilir.
   */
  showConfirm(options: {
    title: string;
    text?: string;
    html?: string;
    confirmText?: string;
    cancelText?: string;
    icon?: 'warning' | 'question' | 'info' | 'error' | 'success';
    focusCancel?: boolean;
    allowOutsideClick?: boolean;
    showCancelButton?: boolean;
  }): Promise<boolean> {
    const {
      title,
      text,
      html,
      confirmText = 'Evet',
      cancelText = 'Vazgeç',
      icon = 'warning',
      focusCancel = true,
      allowOutsideClick = false,
      showCancelButton = true
    } = options;
    return Swal.fire({
      title,
      text: html ? undefined : text,
      html: html || undefined,
      icon,
      showCancelButton,
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
      focusCancel,
      allowOutsideClick
    }).then(r => r.isConfirmed === true);
  }

}
  // showSave<T>(

  //   name: string,
  // ): Observable<boolean> {
  //   return from(Swal.fire({
  //     title: name + ' Kaydedilecek?',
  //     text: "Kaydetmek istiyor musunuz!",
  //     icon: 'warning',
  //     showConfirmButton: true,
  //     showDenyButton: true,
  //     // showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     denyButtonColor: '#d33',
  //     // cancelButtonColor: '#d33',
  //     confirmButtonText: 'Evet, kaydet!',
  //     denyButtonText: 'Hayır, kaydetme!',
  //     preConfirm: () => {
  //       Swal.update({
  //         showDenyButton: false,
  //         text: name + ' Kaydediliyor..',
  //       });
  //       Swal.showLoading();
  //       // cancelButtonText: 'Vazgeç, silme!'
  //       this.confirmEmitter.emit(true);

  //     }
  //   }).then((result): boolean => {
  //     if (result.isConfirmed) {

  //       Swal.fire(
  //         'Kaydedildi!',
  //         name + ' Kaydedildi.',
  //         'success'
  //       )
  //       return true
  //     }
  //     else if (result.isDenied) {
  //       Swal.fire(
  //         'Vazgeçtiniz!',
  //         name + ' Kaydedilemedi.',
  //         'error'
  //       )
  //       return false

  //     }
  //     else if (result.isDismissed) {
  //       Swal.fire(
  //         'Vazgeçtiniz!',
  //         name + ' Kaydedilemedi.',
  //         'success'
  //       )
  //       return false
  //     }
  //     else {
  //       return false
  //     }
  //   })
  //   )
  // }
